import { useEffect, useState } from "react";

import { cn } from "tools/ui";
import HomeCard from "../Components/HomeCard";
import MelhousPage from "../Components/MelhousPage";
import SetupGuide from "../Components/SetupGuide";
import SiteAside from "../Components/SiteAside";
import { fetchCounts } from "../helpers/counts";
import useOpenView from "../helpers/useOpenView";
import { HOME_CARDS, STYLE_SITE_LAYOUT, VIEW_HOME } from "../constants";

function MelhousHome() {
  const onOpen = useOpenView();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let cancelled = false;
    async function load() {
      const result = await fetchCounts(HOME_CARDS);
      if (!cancelled) setCounts(result);
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <MelhousPage view={VIEW_HOME}>
      <div className={cn(STYLE_SITE_LAYOUT, "p-3 lg:p-4")}>
        <div className="flex min-w-0 flex-col gap-4">
          <SetupGuide onOpen={onOpen} />
          <div className="grid grid-cols-1 content-start gap-4 sm:grid-cols-2">
            {HOME_CARDS.map((card) => (
              <HomeCard
                key={card.id}
                card={card}
                count={counts[card.id]}
                onOpen={onOpen}
              />
            ))}
          </div>
        </div>
        <SiteAside />
      </div>
    </MelhousPage>
  );
}

export default MelhousHome;
